module.exports = __webpack_public_path__ + "img/CACE.ae93e1a5.svg";